import React from "react";
import { useQuery } from "@apollo/client";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_PUMPING_STATIONS } from "../../../queries/archiveQrys/InventoryReportQueries";
import { waterSystemStatus, activityType, availabilityType } from "../../../utilities/constants/WaterSystemConstants";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const PumpingStationTable = ({ systemId }) => {
  const columns = [
    {
      Header: "ID",
      accessor: "pumpingStationId",
      width: 55
    },
    {
      Header: "Station Name",
      accessor: "pumpingStationName",
      width: 300
    },
    {
      Header: "Status",
      accessor: (d) => {
        return d.status ? waterSystemStatus[d.status] : "";
      },
      width: 75
    },
    {
      Header: "Reason",
      accessor: (d) => {
        return d.statusReason ? activityType[d.statusReason] : "";
      }
    },
    {
      Header: "Capacity",
      id: "capacity",
      accessor: (d) => {
        return d.capacity ? d.capacity : "";
      },
      width: 75
    },
    {
      Header: "Capacity Unit",
      accessor: (d) => {
        return d.capacityUnit ? d.capacityUnit : "";
      },
      width: 115
    },
    {
      Header: "Availability",
      accessor: (d) => {
        return d.availabilityType ? availabilityType[d.availabilityType] : "";
      },
      width: 100
    }
  ];

  const { loading,error, data } = useQuery(GET_PUMPING_STATIONS, { variables: { systemId } });
  let totalCapacity = 0;
  let uom = "";

  if (loading) {
    return <SkeletonLoader width='100%'/>;
  } else if(error){
    return <ErrorHandler error={error} />
  }else {
    let stationArray = data.getPumpingStationsBySystemId;
    stationArray.forEach((station) => {
      if (station.capacity !== 1) {
        totalCapacity = totalCapacity + station.capacity;
        uom = station.capacityUnit;
      }
    });
  }

  return (
    <>
      {data.getPumpingStationsBySystemId.length > 0 ? (
        <>
          <DtsReactTable data={data.getPumpingStationsBySystemId} columns={columns} headerColor="ddw" cypressid="PumpingStationsTable" />
          <h5>
            Total Capacity: {totalCapacity} {uom}
          </h5>
        </>
      ) : (
        <span>
          <em>No data for pumping stations was found in the database.</em>
        </span>
      )}
    </>
  );
};

export default PumpingStationTable;
